export default {
  addNewAddress: 'Add new address',
  selectedPointAddress: 'Selected point address',
  pleaseSelectAddressCoordinates: 'Please select address coordinates',
  changeCoordinates: 'Change address coordinates',
  editAddress: 'Edit address',
  selectAddress: 'Select address',
  select_fromMyAddresses_html: 'Select {title} from my addresses',
  select_fromPoiAddresses_html: 'Select {title} from my pulic addresses',
  noAddressSelected: 'No address selected!'
}
